import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './FormError.styles';

const FormError = props => {
  return (
    <div className={css(styles.error)}>
      {props.title && <div className={css(styles.title)}>{props.title}</div>}
      {props.children && (
        <div className={css(styles.body)}>{props.children}</div>
      )}
    </div>
  );
};

export default FormError;



// WEBPACK FOOTER //
// ./src/components/forms/formerror/FormError.js